// removed by extract-text-webpack-plugin
module.exports = {"TupleContainer":"_23G-f _qZwn8","TupleContainerPrimary":"_3jrJH _3UMML","TupleContainerSecondary":"_1lVH5 _3UpYt","ButtonBook":"_2sUAH","More":"_3NcF5","Box1":"_36y4n","Box2":"_2aJ_T","AirlineDetail":"_16OqW","Price":"_EegW8","RefundType":"_2QTYz","DividerLeft":"_38pXL","Details":"_1PgEn","Line":"_ReFVd","ArrivalDate":"_2S5GZ _YQIT8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/TupleClubbed/TupleClubbed.scss
// module id = 730
// module chunks = 0